module.exports = __webpack_public_path__ + "static/img/title.cf74ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/title.png
// module id = WWew
// module chunks = 1